import React, { Component } from "react";
import "./style.css";
import "../../../../../../../index.css";
class IntelligentMajorDetail extends Component {
  render() {
    const { item } = this.props;
    return (
      <div className="intelligentDataColumn_box">
        <div className="intelligentDataColumn_school_box">
          <div style={{ height: 35, width: 10 }} className="fl"></div>
          <div className="fl">{item.school_code}</div>
          <div className="fl major_left_15">{item.school_name}</div>
          <div className="clear"></div>
        </div>
        <table
          style={{ position: "unset", fontWeight: "normal" }}
          className="intelligentDataHead_table_box"
        >
          <tbody>
            <tr>
              <td
                style={{
                  borderLeft: 0,
                  borderBottom: 0,
                  width: "42%",
                  textAlign: "left",
                  paddingLeft: 5,
                }}
              >
                院校代码、院校（专业）名
              </td>
              <td style={{ width: "10%", borderBottom: 0 }}>计划人数</td>
              <td style={{ width: "5%", borderBottom: 0 }}>学制</td>
              <td style={{ width: "10%", borderBottom: 0 }}>培养层次</td>
              <td style={{ width: "10%", borderBottom: 0 }}>最低分</td>
              <td style={{ borderRight: 0, width: "23%", borderBottom: 0 }}>
                位次号
              </td>
            </tr>
          </tbody>
        </table>
        <table className="intelligentDataColumn_major_table_box">
          <tbody>
            <tr>
              <td
                style={{
                  borderLeft: 0,
                  width: "42%",
                  textAlign: "left",
                  paddingLeft: 5,
                }}
              >
                {item.major_name}
              </td>
              <td style={{ width: "10%" }}>{item.plan_num}</td>
              <td style={{ width: "5%" }}>{item.school_year}</td>
              <td style={{ width: "10%" }}>{item.level}</td>
              <td style={{ width: "10%" }}>{item.score}</td>
              <td style={{ borderRight: 0, width: "23%" }}>{item.rank}</td>
            </tr>
          </tbody>
        </table>
        <div className="intelligentMajorDetail_other_detail_box">
          <div>
            <span>选考要求：</span>
            <span className="font-weight-normal color_5d5d5d ">
              {item.require_subject}
            </span>
          </div>
          <div className="major_top_18">
            <span>学费：</span>
            <span className="font-weight-normal color_5d5d5d ">
              {item.fee}/年
            </span>
          </div>
          <div className="major_top_18">
            <span>备注：</span>
            <span
              className="font-weight-normal color_5d5d5d "
              dangerouslySetInnerHTML={{ __html: item.remark }}
            ></span>
          </div>
        </div>
      </div>
    );
  }
}

export default IntelligentMajorDetail;



// WEBPACK FOOTER //
// ./src/containers/IntelligentBigData/IntelligentBigDataHome/components/IntelligentMajorModal/components/IntelligentMajorDetail/index.js